
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../features/auth/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslationService } from './services/translate-service';
import { FilterPipe } from './pipes/filter.pipe';
import { FormsModule } from '@angular/forms';
import { FormatBreadcrumbLabelPipe } from './pipes/format-breadcrumb-label.pipe';
import { ArabicNumbersPipe } from '../shared/arabic/arabic-numbers.pipe';

@NgModule({

  declarations: [TranslatePipe, FilterPipe, FormatBreadcrumbLabelPipe, ArabicNumbersPipe],
  imports: [
    CommonModule, FormsModule
  ],
  providers: [
    AuthService,
    AuthGuard,
    TranslationService
  ],
  exports: [TranslatePipe, FilterPipe, FormsModule, FormatBreadcrumbLabelPipe, ArabicNumbersPipe]

})
export class CoreModule { }
